module.exports = __webpack_public_path__ + "img/1543017444.fcf40e36.jpg";